import React from 'react';
import { HelpIcon } from './HelpIcon.js';

export interface FieldLabelProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  /** Help text shown in the HelpIcon click-to-expand modal. */
  help?: string;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({ label, htmlFor, required, help }) => (
  <label htmlFor={htmlFor} className="flex items-center gap-1 text-sm font-medium text-heading mb-1">
    {label}
    {required && <span className="text-danger ml-0.5">*</span>}
    {help && <HelpIcon text={help} />}
  </label>
);
